import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    font-size: 24px;
    display: inline-block;
    animation: ${spin} 1s linear infinite;
  }
`;

const Loading = () => {
  return (
    <Wrapper>
      <i className="fa-duotone fa-solid fa-loader" />
    </Wrapper>
  );
};

export default Loading;
